export const languages: any = [
  {
    'key': 'ja-JP',
    'alt': 'Japan',
    'title': '日本語'
  },
  {
    'key': 'en-US',
    'alt': 'United States',
    'title': 'English (US)'
  },
  {
    'key': 'zh-CN',
    'alt': 'China',
    'title': '中文(简体)'
  },
  {
    'key': 'zh-TW',
    'alt': 'Chinese',
    'title': '中文(繁体)'
  },
  {
    'key': 'ko-KR',
    'alt': 'Korea',
    'title': '한국어'
  }
];



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/i18n/languages.model.ts